import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';

import { SpinnerService } from './spinner.service';

declare var $: any;

@Component({
  selector: 'spinner',
  template: `<div id="spinner" class="modal fade" #spinner>
                <div class="modal-dialog modal-spinner">
                  <div class="modal-content">
                    <div class="modal-body">
                      <div class="row spinner">
                          <div class="col-sm-12 col-spinner">
                              <img src="assets/images/cargando.GIF" alt="cargando" />
                          </div>
                      </div>
                      <div class="row">
                          <div class="col-sm-12 col-spinner">
                              <ng-content></ng-content>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>`,
  styles: [`.modal-spinner { width: 300px; }
            .col-spinner { justify-content: center; display: flex; align-items: center; }
            .spinner { padding: 15px 0px 15px 0px; }`]
})
export class SpinnerComponent implements OnInit {
  @ViewChild('spinner') modal: ElementRef;

  constructor(private spinnerService: SpinnerService) {
    this.spinnerService.showSpinner.subscribe(
      (show: boolean) => {
        if (show) {
         $(this.modal.nativeElement).modal('show');
        } else {
          $(this.modal.nativeElement).modal('hide');
        }
      });
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/QA/HistoricoConductor/frontend/src/app/shared/components/spinner/spinner.component.ts